
(function () {
    const TrackingCookieName = "SNHUAdTracking";
    const queryParams = ["adkeyword", "admatchtype", "addevice", "adcampaignid", "adgroupid", "adcampaignname", "adgroupname", "adquery", "adnetwork", "adlocationid", "adplacement"];
    const CookieTrackingDaysActive = 30;
    const CookieTrackingDomain = "snhu.edu";


    function WriteCookie(cookieValue, cookieName) {
        var date = new Date();
        date.setTime(date.getTime() + (1000 * 60 * 60 * 24 * CookieTrackingDaysActive));
        document.cookie = `${cookieName}=${cookieValue};expires=${date};path=/;domain=.${CookieTrackingDomain};`;
    }


    // Convert a list of objects into a serialized format for the cookie.
    function serialize(list) {
        return list.map((val, i) => `${TrackingCookieName}${i + 1}=${escape(JSON.stringify(val))}`)
            .join('&');
    }

    function PopulateCookieFromQueryString() {
        // if querystring is empty, don't bother.
        if (!window.location.search) {
            return;
        }

        // Start with what's on the querystring.
        var qs = window.location.search.replace(/^\?/, '').split('&').reduce((acc, val) => {
            var items = val.split('=');
            var k = items[0];
            var v = items[1];
            acc[k] = v;
            return acc;
        }, {});

        var trackingParams = {};
        for (var key of Object.keys(qs)) {
            if (queryParams.map(function (item) { return item.toLowerCase(); }).indexOf(key.toLowerCase()) > -1) {
                var qsValue = qs[key];
                if (qsValue) {
                    trackingParams[key.toLowerCase()] = qsValue;
                }
            }
        }

        if (Object.keys(trackingParams).length > 0) {
            var trackerValues = [];
            trackerValues.push(trackingParams);
            var trackingCookieValue = serialize(trackerValues);
            WriteCookie(trackingCookieValue, TrackingCookieName);
        }
    }

    PopulateCookieFromQueryString();
})();

